import React, {Component, PropTypes} from 'react';
import RequiredIndicator from './required-indicator';
import styleable from 'react-styleable';
import defaultStyle from './common.style.js';

export class RequiredLabel extends Component {
  render() {
    const { hasErrors, isRequired, content, htmlFor, css } = this.props;

    if(!content)
      return null;

    return(
      <label className={css.requiredLabel} aria-label={content} htmlFor={htmlFor}>
        {hasErrors ? <span className={css.errorIndicator} aria-hidden='true'/> : null}
        {content}
        <RequiredIndicator css={css} isRequired={isRequired}/>
      </label>
    );
  }
}

RequiredLabel.defaultProps = {
  isRequired: false
};

RequiredLabel.propTypes = {
  hasErrors: PropTypes.bool,
  htmlFor: PropTypes.string,
  content: PropTypes.string.isRequired,
  isRequired: PropTypes.bool
};

export default styleable(defaultStyle) (RequiredLabel);



// WEBPACK FOOTER //
// src/common/required-label.js